module.exports = __webpack_public_path__ + "static/media/eyeLotion2.797d20b2.jpg";